<template>
  <span
    class="app-icon"
    :class="`app-icon--${size}`"
    :style="{ background: gradient }"
    aria-hidden="true"
  >
    <i :class="icon"></i>
  </span>
</template>

<script>
export default {
  name: 'AppIcon',
  props: {
    icon: {
      type: String,
      required: true,
    },
    gradient: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
      validator: (value) => ['xs', 'sm', 'md', 'lg'].includes(value),
    },
  },
};
</script>

<style scoped>
.app-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.16);
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.app-icon--xs {
  width: 24px;
  height: 24px;
  border-radius: 7px;
  font-size: 0.65rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.14);
}

.app-icon--sm {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  font-size: 0.85rem;
}

.app-icon--md {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  font-size: 1.2rem;
}

.app-icon--lg {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  font-size: 1.45rem;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
}
</style>
